import React, { useState } from 'react'
import { Tooltip } from 'react-tooltip'
import styled from 'styled-components'
import dwaLightWeb from '@nexiahome/ui-common/themes/dwa-light-web'
import useResponsiveScreen from '@nexiahome/ui-common/themes/util/useResponsiveScreen'

import Modal from 'components/Modal'

import Alerts from 'pages/shared/AlertsTooltip/Alerts'
import TooltipContent from 'pages/shared/AlertsTooltip/TooltipContent'

import { color } from 'styles/colors'
import { Alert, DeviceConnectionState } from 'types/Alert'

type Props = {
  alerts: Array<Alert>,
  deviceConnectionState?: Array<DeviceConnectionState> | null
}

const AlertsTooltip = ({ alerts, deviceConnectionState = [] }: Props) => {
  const { breakpoints } = dwaLightWeb
  const { isPortrait, screenSize } = useResponsiveScreen({ breakpoints })
  const [isTooltipOpen, setTooltipOpen] = useState(false)
  const [displayModal, setDisplayModal] = useState(false)
  const [displayAlertIds, setDisplayAlertIds] = useState<string | null>(null)

  const OnModalCloseCallback = () => {
    setTooltipOpen(false)
    setDisplayModal(false)
  }

  return (
    <>
      <S.Tooltip
        id="alert-tooltip"
        imperativeModeOnly={displayModal}
        clickable
        delayHide={200}
        isOpen={isTooltipOpen}
        setIsOpen={(open) => setTooltipOpen(open)}
        afterShow={() => {
          setDisplayModal((screenSize === 'sm' || screenSize === 'xs') && !isPortrait)
        }}
        render={({ content }) => {
          return (
            <TooltipContent
              allAlerts={alerts}
              deviceConnectionState={deviceConnectionState}
              screenSize={screenSize}
              displayAlertIds={content}
              isPortrait={isPortrait}
              setDisplayAlertIds={setDisplayAlertIds}
            />
          )
        }}
      />
      {displayModal && (
        <S.Modal isDisplayed={displayModal} fullScreen scroll="paper" closeCallback={OnModalCloseCallback}>
          <Alerts alerts={alerts} displayAlertIds={displayAlertIds} deviceConnectionState={deviceConnectionState} />
        </S.Modal>)
      }
    </>

  )
}

const S = {
  // using important to override the default tooltip style
  Tooltip: styled(Tooltip)`
    background-color: ${color('background')} !important;
    border-radius: 4px;
    z-index: 9999;
    opacity: 1 !important;
    padding: 0 !important;
    box-shadow: 0 0 0 1px ${color('border')} !important;
  `,
  Modal: styled(Modal)`
    overflow: hidden;
  `
}

export default AlertsTooltip
